import React, { Component } from 'react';

import { ApiHelper } from '../../helpers/ApiHelper';
import { AppHelper } from '../../../helpers/AppHelper';
import { Helper } from '../../helpers/Helper';
import { BaseEntityPage } from '../BaseEntityPage';
import { AppStyles } from '../../../styles/AppTheme';
import { Link } from 'react-router-dom';
import { Tooltip } from '@material-ui/core';
import { css, StyleSheet } from 'aphrodite';

export class Sections extends BaseEntityPage {

  constructor(props) {
    super(props);
    this.pageTitle = 'Sections'
    this.quizId = this.props.match.params.quizId
    this.groupId = 'sec' + this.quizId
    this.breadCrumbs = [
      { title: 'Home', to: '/admin' },
      { title: 'Sections' },
    ]
    this.toFetch = [
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['items'], { parentId: 'ROOT', pb: 'fieldDef', groupId: this.groupId }) },
    ]
    this.tableHeadersMap = {
      'Id / Order': (current) => {return (
        <div>
          <span className={css(Styles.spanValue)}>{current.id + ' / ' + current.order}</span>
          <br />
          <span className={css(Styles.spanValue)}>{current.image ? 'Image (Yes)' : 'Image (No)'}</span>
        </div>
      )},
      Title: (current) => current.title,
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      groupId: this.groupId,
      parentId: 'ROOT'
    }
  }

  onFetchSuccess(results) {
    this.formDefinition = results[0].fieldDef;
    this.setState({
      items: Helper.sortDictArray(results[0].items),
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) {
      return ''
    }
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['items'], { groupId: this.groupId }),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'DELETE',
      apiEndPoint: ApiHelper.makeUrlPath(['items', current.id], { groupId: this.groupId }),
    });
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['items', current.id], { groupId: this.groupId }),
    });
  }

  onActions = (current) => {
    const actions = []
    actions.push(AppHelper.buttonEdit(this, current))
    actions.push(
      <Link to={'/admin/quiz/' + this.quizId + '/' + current.id} key={current.id + '-subsections'}>
        <Tooltip title='SubSections' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons'>subdirectory_arrow_right</i>
          </span>
        </Tooltip>
      </Link>
    )
    actions.push(AppHelper.buttonDelete(this, current))
    return actions
  }
}

const Styles = StyleSheet.create({
  spanValue: {
    fontSize: 12
  }
})


// WEBPACK FOOTER //
// ./src/common/components/quizcreator/Sections.js